import React, { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { RootState } from "../services/rootReducer";
// toast + redux slice
import Toast from './toast/Toast';
import { removeFromQueue } from "../services/Toasts_Slice";

const ToastsContainer = () => {
    const dispatch = useDispatch();
    const {toastQueue, position, autoDismiss, dismissTime} = useSelector(
        (state: RootState) => ({
            toastQueue: state.Toasts.toastQueue,
            position: state.Toasts.position,
            autoDismiss: state.Toasts.autoDismiss,
            dismissTime: state.Toasts.dismissTime,
        }),
        shallowEqual
    );

    //
    // when toast deleted
    //
    const onDeleted = useCallback((id: number) =>{
        dispatch(removeFromQueue(id));
    }, [dispatch]);

    /*
    const doAddToast = (type: number, title: string, description: string) =>{
        const toastProperties: toastListProp = createToastProperties(type, title, description);
        console.log("#### will dispatch toast property:"+JSON.stringify(toastProperties));
        dispatch(addToQueue(toastProperties));
    }*/

    return(
        <div className="toastContainer">
            <Toast 
                toastList={toastQueue}
                position={position}
                autoDismiss={autoDismiss}
                /*autoDismiss={true}*/
                dismissTime={dismissTime}
                onDeleted={onDeleted}
                //onCreated={onCreated}
            />
        </div>
    )

}

export default React.memo(ToastsContainer)